var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Box, Card, useTheme, useMediaQuery, } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FInput } from "../../../components/inputs/FInput";
import { SButton } from "../../../components/buttons/SButton";
import { useNavigate } from "react-router-dom";
import { centered } from "@ui/components/style/style";
import { toast } from "@ui/utils/toaster";
import { useAppDispatch, useAppSelector } from "@application/store/useStore";
import { sendOtp } from "@reducers/auth/thunk/auth";
import { clearAuthErrors } from "@reducers/auth/slice/auth";
import localStorageAccessor from "@utility/local-storage-accessor";
const LoginPage = () => {
    const { t } = useTranslation(["form", "validation", "common"]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { otpLoading, error, errors } = useAppSelector((state) => state.auth);
    const { control, handleSubmit, formState: { errors: formErrors }, } = useForm({
        defaultValues: {
            email: "",
        },
    });
    // Clear any existing auth errors when component mounts
    useEffect(() => {
        dispatch(clearAuthErrors());
    }, [dispatch]);
    const onSubmit = (data) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield dispatch(sendOtp(data.email))
                .unwrap()
                .then(() => {
                toast.success(t("common:toasts.otpSent"));
                localStorageAccessor.setOtpEmail(data.email);
                navigate("/otp");
            })
                .catch((error) => {
                toast.error(typeof error === "string"
                    ? error
                    : t("common:toasts.failedToSendOtp"));
            });
        }
        catch (error) {
            toast.error(typeof error === "string" ? error : t("common:toasts.failedToSendOtp"));
        }
    });
    return (React.createElement(Box, { sx: {
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 0,
            position: "relative",
            px: { xs: 1, md: 2 },
            "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundImage: `url(/assets/images/login-bg.jpg)`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                zIndex: -1,
            },
            "&::after": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "#00000040", // Dark overlay
                zIndex: -1,
            },
        } },
        React.createElement(Card, { sx: Object.assign(Object.assign({ width: "100%", maxWidth: 494, minHeight: isMobile ? 400 : 566, borderRadius: 4, backgroundColor: "#FFFFFFE5", backdropFilter: "blur(40px)" }, centered), { flexDirection: "column" }) },
            React.createElement(Box, { sx: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    mb: 4,
                } },
                React.createElement("img", { src: "/assets/images/logo.svg", alt: "logo" })),
            React.createElement(Box, { component: "form", onSubmit: handleSubmit(onSubmit), sx: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 1.5,
                    width: "100%",
                    maxWidth: 354,
                } },
                React.createElement(FInput, { name: "email", control: control, label: "form:fields.email", type: "email", size: "medium", rules: {
                        required: t("validation:email.required"),
                        pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: t("validation:email.invalid"),
                        },
                    }, error: formErrors.email }),
                React.createElement(SButton, { type: "submit", variant: "contained", 
                    // fullWidth
                    size: "large", color: "inherit", loading: otpLoading }, t("common:actions.login"))))));
};
export default LoginPage;
